<template>
  <v-form v-model="check">
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить персону</span>
              <span v-else> <div>Добавить персону</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text v-if="lang.length > 0">

            <v-card-text class="text-xs-left subheading">
              Фамилия:
            </v-card-text>
            <div v-for="item, i in value.lastName">
              <v-text-field
                :error="hasError('lastName')"
                :error-messages="getError('lastName')"
                :label=findLang(value.lastName[i].language)
                required
                outline
                v-model="value.lastName[i].text"
              ></v-text-field>
            </div>

            <v-card-text class="text-xs-left subheading">
              Имя:
            </v-card-text>
            <div v-for="item, i in value.firstName">
              <v-text-field
                :error="hasError('firstName')"
                :error-messages="getError('firstName')"
                :label=findLang(value.firstName[i].language)
                required
                outline
                v-model="value.firstName[i].text"
              ></v-text-field>
            </div>

            <v-card-text class="text-xs-left subheading">
              Отчество:
            </v-card-text>
            <div v-for="item, i in value.patronymic">
              <v-text-field
                :error="hasError('patronymic')"
                :error-messages="getError('patronymic')"
                :label=findLang(value.patronymic[i].language)
                required
                outline
                v-model="value.patronymic[i].text"
              ></v-text-field>
            </div>
            <v-alert
              :value="true"
              color="info"
              icon="info"
              outline
            >
              Обязательно для членов дисс. совета.
            </v-alert>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="value.birthday"
                  readonly
                  :error="hasError('birthday')"
                  :error-messages="getError('birthday')"
                  label="Дата рождения"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                locale="ru"
                v-model="value.birthday"
                :max="new Date().toISOString().substr(0, 10)"
                min="1900-01-01"
                first-day-of-week='1'
                @change="save"
              ></v-date-picker>
            </v-menu>

            <v-autocomplete
              class="pt-4"
              :error="hasError('academicRank')"
              :error-messages="getError('academicRank')"
              :items="selectors.academicRank"
              label="Учёное звание"
              v-model="value.academicRank"
              no-data-text="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('workPlace')"
              :error-messages="getError('workPlace')"
              :items="selectors.workPlace"
              label="Место работы"
              v-model="value.workPlace"
              no-data-text="Нет данных"
            >
              <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="addOrganization = true"
                >
                  <v-list-tile-action>
                    <v-icon>add</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Добавить новую организацию</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>

            <v-layout v-if="value.academicDegree.length == 0">
              <v-card-text class="text-xs-left subheading">Учёная степень (по специальности)</v-card-text>
              <v-spacer></v-spacer>
              <v-btn flat icon class="primary" @click="addacademicDegree" >
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>


            <v-layout v-for="item, i in  value.academicDegree">
              <v-autocomplete
                :error="hasError('academicDegree')"
                :error-messages="getError('academicDegree')"
                :items="selectors.academicDegree"
                label="Учёная степень (по специальности)"
                v-model="item.academicDegree"
                no-data-text="Нет данных"
              ></v-autocomplete>

              <v-autocomplete
                :error="hasError('academicDegree')"
                :error-messages="getError('academicDegree')"
                :items="selectors.scientificIndustry"
                label="Отрасль науки"
                v-model="item.scientificIndustry"
                no-data-text="Нет данных"
              ></v-autocomplete>

              <v-btn flat icon class="primary" @click="addacademicDegree">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn flat icon class="primary" v-if="value.academicDegree.length > 0"
                     @click="deleteData(i,'academicDegree')">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>


            <v-card-text class="text-xs-left subheading">
              Должность
            </v-card-text>
            <div v-for="item, i in value.post">
              <v-text-field
                :error="hasError('post')"
                :error-messages="getError('post')"
                :label=findLang(value.post[i].language)
                required
                outline
                v-model="value.post[i].text"
              ></v-text-field>
            </div>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-progress-circular v-else class="mt-3"
                               :size="70"
                               color="primary"
                               indeterminate
          />
          <v-divider class="mt-5"></v-divider>

          <v-dialog @input="loadAddOrganization" v-model="addOrganization" width="500" persistent>
            <Organization @addItem="loadAddOrganization"
                          @ended="addOrganization = false"
                          @refreshItem="loadAddOrganization"
                          v-if="addOrganization"
            >
            </Organization>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
    // import urls from "../../../../../urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import {makeGetRequest} from "../../../../../helper";
    import urls from "../../../../../modules/petition/urls"
    import Organization from "./Organization"

    export default {
        name: "Person",
        mixins: [UserDataFormMixin],
        components: {Organization},
        props: {
            id: Number,
        },
        watch: {
            menu(val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
        },

        data() {
            return {
                menu: false,
                check: true,
                addOrganization: false,
                URL_CREATE: process.env.VUE_APP_API_HOST + "council/admin/core/models/person/",
                URL_UPDATE: process.env.VUE_APP_API_HOST + "council/admin/core/models/person/<id>/",
                lang: [],
                selectors: {
                    academicRank: [],
                    academicDegree: [],
                    workPlace: [],
                    scientificIndustry: []
                },
                value: {
                    id: this.id || '',
                    lastName: [],
                    firstName: [],
                    patronymic: [],
                    post: [],
                    birthday: undefined,
                    academicRank: null,
                    academicDegree: [
                        {
                            academicDegree: null,
                          scientificIndustry: null
                        }
                    ],
                    workPlace: this.workPlace || null,
                },

            }
        },
        methods: {
            loadAddOrganization() {
              this.addOrganization = false;
              this.selectors.organization = [];
              let url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/organization/"
              this.load(this, url, "organization")
            },
            addacademicDegree() {
                this.value.academicDegree.push(
                    {
                        academicDegree: null,
                      scientificIndustry: null
                    }
                )
            },
            deleteData(idx, key) {
                if (this.value[key].length > 0)
                    this.value[key].splice(idx, 1);
            },
            text: item => item.name[0].text,
            save(date) {
                this.$refs.menu.save(date)
            },
            findLang(langid) {
                let str = this.lang.find(x => x.id === langid).name;
                return str
            },
            closeDialog() {
                this.$emit('ended', '')
            },
            load: function (app, url) {
                if (url === null) {
                    app.loadingPage = true;
                    this.selectors.workPlace.push({text:'Не выбрано',value:null})
                    return;
                }
                makeGetRequest(url)
                    .then(resp => resp.json())
                    .then(json => {
                        let next_url = null;
                        if (json['next'] !== null)
                            next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
                        for (let i in json['results']) {
                            app.selectors.workPlace.push(Object.assign({}, json['results'][i]));
                        }
                        app.load(app, next_url);
                    });
            },
        },
        created() {
            let url = process.env.VUE_APP_API_HOST + "council/admin/core/models/language/"
            let sys = true
            makeGetRequest(url).then(resp => {
                if (!resp.ok) {
                    sys = false
                }
                return resp.json()
            }).then(json => {
                this.lang = json

                if (this.value.lastName.length === 0) {
                    for (let key in this.lang) {
                        this.value.lastName.push({"text": "", "language": this.lang[key].id})
                        this.value.firstName.push({"text": "", "language": this.lang[key].id})
                        this.value.patronymic.push({"text": "", "language": this.lang[key].id})
                        this.value.post.push({"text": "", "language": this.lang[key].id})
                    }
                } else if (this.value.lastName.length !== this.lang.length) {
                    //если добавили новый предмет и редактируем
                    for (let key in this.lang) {
                        let answ = this.value.lastName.find(x => x.language === this.lang[key].id);
                        if (answ === undefined) {
                            this.value.lastName.push({"text": "", "language": this.lang[key].id})
                            this.value.firstName.push({"text": "", "language": this.lang[key].id})
                            this.value.patronymic.push({"text": "", "language": this.lang[key].id})
                            this.value.post.push({"text": "", "language": this.lang[key].id})
                        }
                    }
                }

                let url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/academic_rank/"
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors.academicRank = json
                  this.selectors.academicRank.push({text:'Не выбрано',value:null})
                })
                url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/academic_degree/"

                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors.academicDegree = json
                  // this.selectors.academicDegree.push({text:'Не выбрано',value:null})
                })

                url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/scientific_industry/"

                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors.scientificIndustry = json
                    // this.selectors.scientificIndustry.push({text:'Не выбрано',value:null})
                })

                url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/organization/"
                this.load(this, url)

                if (this.id !== undefined) {
                    makeGetRequest(this.URL_UPDATE.replace("<id>", this.id)).then(resp => {
                        if (!resp.ok) {
                            sys = false
                        }
                        return resp.json()
                    }).then(json => {
                        this.value = json
                        if(json.academicRank  !== null)
                           this.value.academicRank = json.academicRank.id;
                        if(json.workPlace  !== null)
                          this.value.workPlace = json.workPlace.id;
                        let urlsci = new URL(urls.getUrl('admin|core|models|person_academic_degree-list', 'list'));
                        let params = json.academicDegree.get_params;
                        urlsci.search = new URLSearchParams(params).toString();
                        this.value.academicDegree = [];
                        makeGetRequest(urlsci).then(resp => {
                            return resp.json()
                        }).then(json2 => {
                            let d = json2
                            if (d.length > 0) {
                                this.value.academicDegree = [];
                                for (let key in d) {
                                    this.value.academicDegree.push(
                                        {
                                            academicDegree: d[key].academicDegree,
                                          scientificIndustry: d[key].scientificIndustry
                                        }
                                    )
                                }
                            }
                        })

                    })
                }

            })
        }
    }

</script>

<style scoped>

</style>
